import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/auction/payment.ts
import { Exception } from "@wbk/logger";
var getAuctionPaymentDetails = (_0) => __async(void 0, [_0], function* ({ id, lang }) {
  try {
    const data = yield fetchClient({
      url: `/auction/waiting-payment/${id}?lang=${lang}`
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getAuctionPaymentDetailsException",
      context: { extra: { id, lang } }
    });
  }
});

export {
  getAuctionPaymentDetails
};
//# sourceMappingURL=chunk-FEFRDEYL.mjs.map